import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';

import { CLAIMCHAIN_NUMBER } from 'cml-script';
import React from 'react';

export default function FilterClaimchainInMap({ value, onChange }) {
  const _onChange = (e) => {
    const { checked, name } = e.target;
    const _value = [...value];
    _value[Number(name)] = checked ? Number(name) + 1 : null;
    onChange(_value);
  };
  return (
    <Box
      sx={{
        px: '22px',
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 'bold',
        }}
      >
        Show Claimchain in map
      </Typography>
      <FormGroup>
        {CLAIMCHAIN_NUMBER.map((item, index) => {
          return (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={Boolean(value[index])}
                  onChange={_onChange}
                />
              }
              name={index}
              label={item.label}
              sx={{
                '& .MuiTypography-root': {
                  fontSize: '12px',
                },
              }}
            />
          );
        })}
      </FormGroup>
    </Box>
  );
}
